// extracted by mini-css-extract-plugin
export default {"header":"Header_header__yHd49","link":"Header_link__P5nTA","balance":"Header_balance__Y2OSO","hero":"Header_hero__17cHz"};